// Клавиша, с которой колесо приближает карту: на Mac — ⌘, иначе Ctrl (оба работают везде).
export const ZOOM_KEY =
  typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.userAgent) ? "⌘" : "Ctrl";
